module.exports = __webpack_public_path__ + "img/logo_confirmacion.f2730ce5.png";